
















import {Component} from '@/shared/component';
import {AbstractSearchVue} from '@/components/Abstract/AbstractSearchVue';

import InputSearchEntity from '@/components/Input/SearchEntity.vue';
import CrudBoisTypeFilter from '@/components/Crud/BoisType/Filter.vue';
import CrudBoisTypeList from '@/components/Crud/BoisType/List.vue';

@Component({
	components: {
		CrudBoisTypeFilter,
		CrudBoisTypeList,
		InputSearchEntity,
	}
})
export default class CrudBoisTypeSearch extends AbstractSearchVue {
	private filterComponent = CrudBoisTypeFilter;
	private listComponent = CrudBoisTypeList;
}
